import React from "react";

export default function CustomTextArea({
  label,
  type,
  customClass,
  placeholder,
  onChange,
  onBlur,
  name,
  value,
  touched,
  error,
  onKeyPress,
  disabled,
  rows,
}) {
  return (
    <div className="common-modal-field">
      <label>{label}</label>
      <textarea
        disabled={disabled}
        type={type}
        name={name}
        value={value}
        className={`form-control ${customClass}`}
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur}
        onKeyPress={onKeyPress}
        rows={rows}
      />
      {touched && error && (
        <p style={{ color: "red", marginBottom: 0 }}>{error}</p>
      )}
    </div>
  );
}
